import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import Header from "./Header"

// ----------------------------------------------------------------------------

function _Layout(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, tabs } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <Header className="app-header" tabs={tabs} />
            <div className="main-wrapper">
                <main className="main-content">{props.children}</main>
            </div>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_Layout.propTypes = {
    className: PropTypes.string.isRequired,
    noPadding: PropTypes.bool,
}

_Layout.defaultProps = {}

// ----------------------------------------------------------------------------

const Layout = styled(_Layout)`
    & {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        .app-header {
            z-index: 100;
        }
        .main-wrapper {
            /* margin-top: ${(props) =>
                props.theme.spacing.menuMarginBottom}; */
            background-color: ${(props) => props.theme.colors.mainBackground};
            flex: 1;
            min-height: 100%;
            padding-top: 20px;
        }
        &.image-background {
            /* .app-header {
                margin-bottom: ${(props) =>
                props.theme.spacing.menuMarginBottom};
            } */
            .main-wrapper {
                margin-top: 0;
                background-color: transparent;
            }
        }
        &.login-page {
            .main-wrapper {
                background-color: ${(props) => props.theme.colors.dark100};
                margin: 0;
                min-height: calc(
                    100vh - ${(props) => props.theme.spacing.padding} * 2 -
                        ${(props) => props.theme.font.logo.height}
                );
            }
        }
        &.agency {
            .main-wrapper {
                background-color: ${(props) => props.theme.colors.dark100};
                margin: 0;
                padding-top: ${(props) => props.theme.spacing.menuMarginBottom};
                padding-left: ${(props) => props.theme.spacing.layoutPadding};
                padding-right: ${(props) => props.theme.spacing.layoutPadding};
                padding-bottom: ${(props) => props.theme.spacing.layoutPadding};
                min-height: calc(
                    100vh - ${(props) => props.theme.spacing.padding} * 2 -
                        ${(props) => props.theme.font.logo.height}
                );
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default Layout
